import { Plus } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { toDayMonth } from "@/shared/utils/date";
import type { PatchResponse } from "../settings.patch.utils";

export function PatchList({
  patches,
  onSelect,
  onCreate,
}: {
  patches: PatchResponse[];
  onSelect: (patchId: string) => void;
  onCreate: () => void;
}) {
  const newestFirst = [...patches].sort(
    (left, right) =>
      right.startsOn.localeCompare(left.startsOn) ||
      left.name.localeCompare(right.name, "sv"),
  );

  return (
    <section className="max-w-3xl space-y-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold">Patches</h2>
        </div>
        <Button type="button" onClick={onCreate}>
          <Plus />
          Lägg till patch
        </Button>
      </div>

      {newestFirst.length === 0 ? (
        <p className="rounded-lg border border-dashed p-6 text-sm text-muted-foreground">
          Det finns inga patchar ännu.
        </p>
      ) : (
        <div className="divide-y overflow-hidden rounded-lg border">
          {newestFirst.map((patch) => (
            <button
              key={patch.id}
              type="button"
              className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset"
              onClick={() => onSelect(patch.id)}
            >
              <span>
                <span className="block font-medium">{patch.name}</span>
                <span className="block text-sm text-muted-foreground">
                  {toDayMonth(patch.startsOn)} → {toDayMonth(patch.endsOn)}
                </span>
              </span>
              <span className="text-sm text-muted-foreground">
                {patch.raids.length}{" "}
                {patch.raids.length === 1 ? "raid" : "raids"}
              </span>
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
